/**
 * A short, dismissible message about something the user asked for and did not
 * get. Deliberately non-blocking: whatever they asked for still goes ahead as
 * best it can, and this only explains why it went ahead differently.
 */

import React from 'react';
import PropTypes from 'prop-types';
import './WorkspaceNotice.css';

function WorkspaceNotice({ children, onDismiss }) {
    return (
        <div className="ws-notice" role="status">
            <span className="ws-notice-dot" aria-hidden="true" />
            <span className="ws-notice-text">{children}</span>
            <button type="button" className="ws-notice-dismiss" onClick={onDismiss} aria-label="Dismiss">
                <svg viewBox="0 0 20 20" fill="currentColor" width="14" height="14">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
            </button>
        </div>
    );
}

WorkspaceNotice.propTypes = {
    children: PropTypes.node,
    onDismiss: PropTypes.func.isRequired,
};

export default WorkspaceNotice;
